import * as React from 'react'
import './index.scss'

const Paragraph = ({ children }) => {
  return <p>{children}</p>
}

export default Paragraph
